import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["url", "error"]
  static values = { url: String }

  onPaste(event) {
    const text = (event.clipboardData || window.clipboardData)?.getData("text") || ""
    if (this.#isUrl(text)) {
      event.preventDefault()
      this.urlTarget.value = text.trim()
      this.fetch()
    }
  }

  onInput() {
    const v = this.urlTarget.value.trim()
    if (this.#isUrl(v) && v !== this.lastFetched) this.fetch()
  }

  async fetch() {
    const url = this.urlTarget.value.trim()
    if (!url || url === this.lastFetched) return
    this.lastFetched = url

    this.clearError()

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        },
        body: JSON.stringify({ url }),
      })

      if (!response.ok) {
        const err = await response.json().catch(() => ({}))
        this.showError(err.error || `HTTP ${response.status}`)
        return
      }

      const data = await response.json()
      this.applyData(data)
    } catch (e) {
      this.showError(e.message)
    }
  }

  applyData(data) {
    const map = {
      first_name: "player[first_name]",
      last_name: "player[last_name]",
      birthdate: "player[birthdate]",
      nationality: "player[nationality]",
      height_eu: "player[height_eu]",
      weight_eu: "player[weight_eu]",
      position_id: "player[position_id]",
      current_team: "player[pro_player_detail_attributes][current_team]",
      agency: "agent_name",
      photo: "player[photo]",
    }

    const form = this.element.closest("form")
    for (const [key, fieldName] of Object.entries(map)) {
      const field = form.querySelector(`[name="${fieldName}"]`)
      if (!field) continue
      const value = data[key]
      const hasValue = value !== null && value !== undefined && value !== ""
      if (hasValue) {
        field.value = value
        field.dispatchEvent(new Event("input", { bubbles: true }))
        field.dispatchEvent(new Event("change", { bubbles: true }))
      }
      this.markField(field, hasValue)
    }
  }

  markField(field, ok) {
    const el = field.closest('[data-parser-mark]') || field
    el.classList.remove("border-success/50!", "border-warning/50!")
    el.classList.add(ok ? "border-success/50!" : "border-warning/50!")
  }

  showError(msg) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = msg
      this.errorTarget.classList.remove("hidden")
    }
  }

  clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ""
      this.errorTarget.classList.add("hidden")
    }
  }

  #isUrl(str) {
    try {
      const u = new URL(str.trim())
      return u.protocol === "http:" || u.protocol === "https:"
    } catch {
      return false
    }
  }
}
